/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ScheduledDropEnrollmentRow
 */
export interface ScheduledDropEnrollmentRow {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof ScheduledDropEnrollmentRow
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ScheduledDropEnrollmentRow
     */
    memberId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ScheduledDropEnrollmentRow
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDropEnrollmentRow
     */
    studentName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ScheduledDropEnrollmentRow
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDropEnrollmentRow
     */
    className: string;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof ScheduledDropEnrollmentRow
     */
    teacherIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {any}
     * @memberof ScheduledDropEnrollmentRow
     */
    dropDate: any | null;
}

/**
 * Check if a given object implements the ScheduledDropEnrollmentRow interface.
 */
export function instanceOfScheduledDropEnrollmentRow(value: object): value is ScheduledDropEnrollmentRow {
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('teacherIds' in value) || value['teacherIds'] === undefined) return false;
    if (!('dropDate' in value) || value['dropDate'] === undefined) return false;
    return true;
}

export function ScheduledDropEnrollmentRowFromJSON(json: any): ScheduledDropEnrollmentRow {
    return ScheduledDropEnrollmentRowFromJSONTyped(json, false);
}

export function ScheduledDropEnrollmentRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledDropEnrollmentRow {
    if (json == null) {
        return json;
    }
    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'memberId': ActorActivityRecordActorUserIdFromJSON(json['memberId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'teacherIds': ((json['teacherIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'dropDate': json['dropDate'],
    };
}

export function ScheduledDropEnrollmentRowToJSON(json: any): ScheduledDropEnrollmentRow {
    return ScheduledDropEnrollmentRowToJSONTyped(json, false);
}

export function ScheduledDropEnrollmentRowToJSONTyped(value?: ScheduledDropEnrollmentRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'memberId': ActorActivityRecordActorUserIdToJSON(value['memberId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'teacherIds': ((value['teacherIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'dropDate': value['dropDate'],
    };
}

